import React, {FC, useState} from "react";
import * as fa from "@fortawesome/free-solid-svg-icons"
import {Task} from "../../../lib/src/api/dto/Task";
import {useApi} from "../api/APIContext";
import {ModalFooter} from "@traas/lib/src/components/layout/ModalProvider";
import {Toggle} from "@traas/lib/src/components/form/Toggle";
import {Input} from "@traas/lib/src/components/form/Input";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSquareCheck} from "@fortawesome/free-solid-svg-icons";
import {faSquare} from "@fortawesome/pro-light-svg-icons";


export const SendWorkordersModal: FC<{tasks:Task[], sendNotifications?: boolean}> = (props) => {
  const {sendWorkorders} = useApi()
  const [addNote, setAddNote] = useState<string|null>(null)
  const [isImportant, setIsImportant] = useState<boolean|null>(null)
  const confirm = async () => {
    await sendWorkorders(props.tasks, addNote ? addNote : undefined, isImportant ? isImportant : undefined, props.sendNotifications)
  }

  return <form>
    <p className={""}>
      <strong>Let op!</strong> Je staat op het punt om <strong>{props.tasks.length} {props.tasks.length === 1 ? 'werkbon' : 'werkbonnen'}</strong> te versturen.
      Deze zijn hierna zichtbaar voor de medewerkers van de desbetreffende teams.
    </p>
    <Toggle value={addNote !== null} onChange={(v) => {
      setAddNote(v ? '' : null)
      setIsImportant(v ? false : null)
    }} label={"Voeg een opmerking toe aan alle werkbonnen."} />
    {addNote !== null && <Input label={'Opmerking'} type={'textarea'} value={addNote} onChange={setAddNote} />}
    {addNote !== null && <div className={'flex flex-row items-center px-3 space-x-2 rounded-sm hover:cursor-pointer hover:bg-brand-100 mr-40'} onClick={() => setIsImportant(!isImportant)}>
      <FontAwesomeIcon icon={isImportant ? faSquareCheck : faSquare} className={`text-lg ${isImportant  ? 'text-brand-900' : ''}`} />
      <div className={'py-1 px-1'}>
        <div className={'text-sm'}>Belangrijk</div>
        <div className={'text-xs'}>Hierbij legt de App extra nadruk op de ingevoerde notities</div>
      </div>
    </div>}
    <ModalFooter icon={fa.faPaperPlane} text={"Verzenden"} onSubmit={confirm} />
  </form>
}
